import * as yup from 'yup';

import { validateEmail, validatePostcode } from 'app/utils/validations';

const userDetails = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
});

const companyDetails = yup.object().shape({
  name: yup.string().required('Legal company name is mandatory'),
  number: yup.string().required('Registration number is mandatory'),
  address: yup.string().required('Registered company address is mandatory'),
  city: yup.string().required('Town/City name is mandatory'),
  postCode: yup
    .string()
    .required('Postcode is mandatory')
    .test('Invalid postcode', 'Enter a valid postcode', (value) => validatePostcode(value, 'GB')),
  country: yup.string().required('Country is mandatory'),
});

const createPassword = yup.object().shape({
  password: yup
    .string()
    .required('Password is mandatory')
    .matches(
      /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
      'Your password must contain at least 8 characters, 1 uppercase letter, 1 number (0-9), 1 special character'
    ),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});

const onboardingSchema = {
  userDetails,
  companyDetails,
  createPassword,
};

export default onboardingSchema;
